const createStorefrontClient = () => {
    const executeQuery = async (query, variables = {}) => {
        const cfg = (typeof window !== 'undefined' && window.STOREFRONT_CONFIG) ? window.STOREFRONT_CONFIG : {};
        const requestUrl = `https://${cfg.storeDomain}/api/${cfg.apiVersion}/graphql`;
        const res = await fetch(requestUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Shopify-Storefront-Access-Token': cfg.publicAccessToken,
            },
            body: JSON.stringify({ query, variables })
        });

        if (!res.ok) {
            const text = await res.text();
            throw new Error(`HTTP ${res.status} ${res.statusText}: ${text}`);
        }

        const json = await res.json();
        if (json.errors && json.errors.length) {
            throw new Error(json.errors[0].message || 'GraphQL 错误');
        }
        return json;
    };

    return {
        cart: {
            create: async (input) => {
                const mutation = `
                    mutation cartCreate($input: CartInput!) {
                        cartCreate(input: $input) {
                            cart { id checkoutUrl }
                            userErrors { field message }
                        }
                    }
                `;
                return executeQuery(mutation, { input });
            }
        }
    };
};

customElements.define('custom-checkout-button', class extends HTMLElement {
    constructor() {
        super();
        this.client = createStorefrontClient();
        this.isProcessing = false;
        this.init();
    }

    init() {
        this.addEventListener('click', this.handleClick.bind(this));
        this.setAttribute('role', 'button');
        this.setAttribute('tabindex', '0');
        this.style.cursor = 'pointer';
        this.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                this.handleClick(e);
            }
        });
    }

    async handleClick(e) {
        e.preventDefault();
        if (this.isProcessing) return;

        try {
            this.isProcessing = true;
            this.setLoadingState(true);

            // 从所在的表单读取变体与数量
            const form = this.closest('form');
            if (!form) throw new Error('未找到产品表单');
            const formId = form.getAttribute('id'); // 获取表单的 id 属性

            const idInput = form.querySelector('[name="id"]');
            const variantIdRaw = idInput && idInput.value;
            if (!variantIdRaw) throw new Error('缺少主商品变体 ID');

            // 从关联的数量输入框读取数量（通过 form 属性关联）
            const quantityInput = document.querySelector(`[name="quantity"][form="${formId}"]`);
            const quantity = parseInt((quantityInput && quantityInput.value) ? quantityInput.value : '1', 10);
            if (!quantity || quantity < 1) throw new Error('主商品数量无效');

            const lines = [];

            // 首先收集所有选中的配件产品
            const accessoriesList = document.querySelector('.product-accessories__list');
            if (accessoriesList) {
                const checkedAccessories = accessoriesList.querySelectorAll('.product-accessories__item .product-accessories__item-checkbox input[type="checkbox"]:checked');
                checkedAccessories.forEach(checkbox => {
                    const accessoryVariantId = checkbox.dataset.variantId;
                    if (accessoryVariantId) {
                        const accessoryMerchandiseId = accessoryVariantId.startsWith('gid://shopify/ProductVariant/')
                            ? accessoryVariantId
                            : `gid://shopify/ProductVariant/${accessoryVariantId}`;
                        lines.push({ merchandiseId: accessoryMerchandiseId, quantity: 1 });
                    }
                });
            }

            // 然后添加主产品
            const mainMerchandiseId = variantIdRaw.startsWith('gid://shopify/ProductVariant/')
                ? variantIdRaw
                : `gid://shopify/ProductVariant/${variantIdRaw}`;
            lines.push({ merchandiseId: mainMerchandiseId, quantity });

            const input = { lines };
            const res = await this.client.cart.create(input);

            const userErrors = res.data?.cartCreate?.userErrors || [];
            if (userErrors.length) {
                throw new Error(userErrors[0].message || '创建购物车失败');
            }

            const checkoutUrl = res.data?.cartCreate?.cart?.checkoutUrl;
            if (!checkoutUrl) throw new Error('无法获取结账链接');

            window.location.href = checkoutUrl;
        } catch (err) {
            this.handleError(err);
        } finally {
            this.isProcessing = false;
            this.setLoadingState(false);
        }
    }

    handleError(error) {
        console.error('结账失败:', error);
        const message = error?.message || '出现未知错误，请稍后再试';
        if (window.showToast) {
            window.showToast(message, 'error');
        } else {
            alert(message);
        }
    }

    setLoadingState(isLoading) {
        if (isLoading) {
            this.classList.add('btn--loading');
        } else {
            this.classList.remove('btn--loading');
        }
    }
});